import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import * as nggt from 'angular-gettext';

import { LdaState, SiteConfig } from '../shared';

ng.module('selfReg').run(ageGateConfig);

ageGateConfig.$inject = [
   '$interval', '$window', '$transitions', 'gettextCatalog', 'ldaState', 'config'
];

function ageGateConfig(
   $interval:ng.IIntervalService,
   $window:ng.IWindowService,
   $transitions:uir.TransitionService,
   gettextCatalog:nggt.gettextCatalog,
   ldaState:LdaState,
   config:SiteConfig
) {
   // TODO figure out what to do here once language selector is implemented
   let lang = gettextCatalog.getCurrentLanguage();

   let ldaFailRedirectUrl:string;
   if (config.settings.invalidAgeRedirect && config.settings.invalidAgeRedirect[lang]) {
      ldaFailRedirectUrl = config.settings.invalidAgeRedirect[lang];
   }

   let externalAgeGateUrl:string;
   if (config.settings.externalAgeValidation && config.settings.externalAgeValidation[lang]) {
      externalAgeGateUrl = config.settings.externalAgeValidation[lang];
   }

   // store this early, before any redirects within the app, IE clears it
   let referrer = $window.document.referrer;

   if (config.campaign.ageRequirementType || externalAgeGateUrl) {
      $transitions.onBefore({}, enforceAgeGate);
   }

   if (ldaFailRedirectUrl) {
      $interval(invalidAgeRedirectTimer, 4000);
   }

   function enforceAgeGate(trans:uir.Transition) {
      let state = trans.$to();

      if (!ldaState.passed && externalAgeGateUrl && domainsMatch(externalAgeGateUrl, referrer)) {
         ldaState.passed = true;
      }

      if (state.data && state.data.gated && !ldaState.passed) {
         return trans.router.stateService.target('shell.ageGate', trans.params());
      }

      if (state.name === 'shell.ageGate') {
         if (ldaState.passed) {
            return trans.router.stateService.target('shell.events', trans.params());
         }

         if (externalAgeGateUrl) {
            $window.location.href = externalAgeGateUrl;
            trans.abort();
         }
      }
   }

   // when the age fields have values in them and we navigate back to this
   // site (back button) after being redirected, firefox (safari?) will not
   // reload the page nor will it re-run any javascript...
   // it will however resume timers, so we use an infinite timer to check
   // if we are in a state that requires redirecting
   function invalidAgeRedirectTimer() {
      if (ldaState.redirect) {
         $window.location.href = ldaFailRedirectUrl;
      }
   }
}

function domainsMatch(url1:string, url2:string) {
   if (!url1 || !url2) return false;
   let domain1 = url1.split('/').slice(2, 3).pop();
   let domain2 = url2.split('/').slice(2, 3).pop();
   return domain1 && domain2 && domain1 === domain2;
}
